import { useMemo, useState } from "react"
import { useSearchParams } from "react-router-dom"
import { observer } from "mobx-react"
import { Button, Flex, Radio, Typography } from "antd"
import { choose } from "choose-matching"

import { DefaultPageLayout } from "@src/app/layouts/DefaultPageLayout"
import { MassPayoutsCardsPage } from "@src/pages/massPayouts/cards"
import {
  MassPayoutPageVariants,
  MassPayoutRadioOptions,
} from "@src/pages/massPayouts/constants"
import {
  MassPayoutsCryptoPage,
  MassPayoutsPageView,
} from "@src/pages/massPayouts/crypto"

export const MassPayoutsPage = observer(() => {
  const [view, setView] = useState<MassPayoutsPageView>(
    MassPayoutsPageView.UPLOAD,
  )

  const [searchParams] = useSearchParams()
  const page = searchParams.get("view")

  const isCrypto = useMemo(
    () => page === String(MassPayoutPageVariants.Crypto),
    [page],
  )

  const title = useMemo(
    () => (isCrypto ? "Crypto payouts " : "Card payouts"),
    [isCrypto],
  )

  return (
    <DefaultPageLayout
      button={
        <Radio.Group
          buttonStyle="solid"
          defaultValue="Apple"
          onChange={(v) => setView(v.target.value)}
          optionType="button"
          options={MassPayoutRadioOptions}
          value={view}
        />
      }
      title={title}
    >
      <>
        {choose(
          [isCrypto, <MassPayoutsCryptoPage view={view} />],
          [!isCrypto, <MassPayoutsCardsPage view={view} />],
        )}
      </>
    </DefaultPageLayout>
  )
})
